import React from 'react';
import { ReferenceSectionItems } from './ResearchPopUpItems';
import ModalComponent from 'components/Common/Modal';

const ContentPopup = (props) => {
  return <ReferenceSectionItems {...props} />;
};

const ResearchPopUp = (props) => {
  const { showPopUp, setShowPopup } = props;

  return (
    <ModalComponent
      overlayClassName={'react-modal-overlay adjustment-of-position'}
      isOpen={showPopUp}
      setIsOpen={setShowPopup}
    >
      <ContentPopup {...props} />
    </ModalComponent>
  );
};

export default ResearchPopUp;
